import { useRouter } from 'next/router';
import en from '../../public/lang/en.js';
import jp from '../../public/lang/jp.js';

const useTrans = () => {
    const { locale } = useRouter();

    const trans = locale === 'en' ? en : jp;

    return trans;
};

export default useTrans;